export class InvalidQuestionItemIndexError extends Error {
}
